<!-- @veltra/icons generated sha256:294477ded6e4f592 gen:8 source:src/svg/normal/more-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'MoreFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M12 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0M3 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
    />
  </svg>
</template>
